import { NgModule } from '@angular/core';
import { KeysPipe } from './pipes/keys.pipe';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { CommonModule } from '@angular/common';
// import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon'
import { PhonePipe } from './pipes/phone.pipe';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { PlatformModule } from '@angular/cdk/platform';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { SafePipe } from './pipes/safe.pipe';
import { SafeHtmlPipe } from './pipes/safehtml.pipe';
import { HttpClientModule } from '@angular/common/http';
import {MatLegacyProgressBarModule as MatProgressBarModule} from '@angular/material/legacy-progress-bar';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { NgbDatepickerModule, NgbModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import {CookieService} from 'ngx-cookie-service';

// export const customConfig = {
//   align: "left",
//   allowNegative: false,
//   allowZero: true,
//   decimal: ".",
//   precision: 2,
//   prefix: "$ ",
//   suffix: "",
//   thousands: ",",
//   nullable: true,
//   min: null,
//   max: null,
//   inputMode: InputMode.NATURAL
// };

@NgModule({
  declarations: [KeysPipe, PhonePipe, SafePipe, SafeHtmlPipe],
  imports: [
    CommonModule,
    // HttpModule,
    HttpClientModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MatDatepickerModule, MatFormFieldModule, MatInputModule,
    MatSelectModule, MatAutocompleteModule,
    MatSlideToggleModule, MatButtonModule, MatIconModule,
    MatDialogModule, MatProgressSpinnerModule,
    MatRadioModule,
    PlatformModule,
    MatCardModule,
    MatExpansionModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatButtonToggleModule,
   // NgxCurrencyModule.forRoot(customConfig)
    NgbPopoverModule,
    NgbModule,
    // NgbDatepickerModule
  ],
  exports: [
    CommonModule,
    // HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    KeysPipe, PhonePipe,SafePipe, SafeHtmlPipe,
    MatDatepickerModule, MatFormFieldModule, MatInputModule, MatCheckboxModule,
    MatSelectModule, MatAutocompleteModule,
    MatSlideToggleModule, MatButtonModule, MatIconModule,
    MatDialogModule, MatProgressSpinnerModule,
    MatRadioModule,
    PlatformModule,
    MatCardModule,
    MatExpansionModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatButtonToggleModule,
    NgbPopoverModule,
    NgbModule
  ],
  providers: [
    CookieService
  ]
})
export class SharedModule { }
